export * from '@primeuix/themes/nora/tabmenu';
export { default } from '@primeuix/themes/nora/tabmenu';
